import { CorrectionRequestApi } from "./CorrectionRequestApi";
import { Weekday } from "./BusinessHoursModel";
import { AppUtils } from '../../../../../shared/utils/index';

export class GasStationCorrectionRequestApi extends CorrectionRequestApi {

	private tankstelleName: string;
	public get TankstelleName(): string {
		return this.tankstelleName;
	}
	public set TankstelleName(value: string) {
		this.tankstelleName = value;
	}

	private tankstelleBetreiber: string;
	public get TankstelleBetreiber(): string {
		return this.tankstelleBetreiber;
	}
	public set TankstelleBetreiber(value: string) {
		this.tankstelleBetreiber = value;
	}

	private tankstelleStrasseHausnummer: string;
	public get TankstelleStrasseHausnummer(): string {
		return this.tankstelleStrasseHausnummer;
	}
	public set TankstelleStrasseHausnummer(value: string) {
		this.tankstelleStrasseHausnummer = value;
	}

	private tankstellePostleitzahl: string;
	public get TankstellePostleitzahl(): string {
		return this.tankstellePostleitzahl;
	}
	public set TankstellePostleitzahl(value: string) {
		this.tankstellePostleitzahl = value;
	}

	private tankstelleOrt: string;
	public get TankstelleOrt(): string {
		return this.tankstelleOrt;
	}
	public set TankstelleOrt(value: string) {
		this.tankstelleOrt = value;
	}

	private tankstelleGeoeffnetAm: Weekday;
	public get TankstelleGeoeffnetAm(): Weekday {
		return this.tankstelleGeoeffnetAm;
	}
	public set TankstelleGeoeffnetAm(value: Weekday) {
		this.tankstelleGeoeffnetAm = value;
	}

	private tankstelleGeoeffnetVon: string;
	public get TankstelleGeoeffnetVon(): string {
		return this.tankstelleGeoeffnetVon;
	}
	public set TankstelleGeoeffnetVon(value: string) {
		this.tankstelleGeoeffnetVon = value;
	}

	private tankstelleGeoeffnetBis: string;
	public get TankstelleGeoeffnetBis(): string {
		return this.tankstelleGeoeffnetBis;
	}
	public set TankstelleGeoeffnetBis(value: string) {
		this.tankstelleGeoeffnetBis = value;
	}

	private tankstelleLatitude: number;
	public get TankstelleLatitude(): number {
		return this.tankstelleLatitude;
	}
	public set TankstelleLatitude(value: number) {
		this.tankstelleLatitude = value;
	}

	private tankstelleLongitude: number;
	public get TankstelleLongitude(): number {
		return this.tankstelleLongitude;
	}
	public set TankstelleLongitude(value: number) {
		this.tankstelleLongitude = value;
	}

	constructor(initialProperties?: Partial<GasStationCorrectionRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	public static createFromObject(dataObject: { [key: string]: any }): GasStationCorrectionRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, GasStationCorrectionRequestApi);
	}

	public toRequestObject(): { [key: string]: any } {
		const result = super.toRequestObject();
		result.TankstelleName = this.TankstelleName;
		result.TankstelleBetreiber = this.TankstelleBetreiber;
		result.TankstelleStrasseHausnummer = this.TankstelleStrasseHausnummer;
		result.TankstellePostleitzahl = this.TankstellePostleitzahl;
		result.TankstelleOrt = this.TankstelleOrt;
		result.TankstelleGeoeffnetAm = this.TankstelleGeoeffnetAm;
		result.TankstelleGeoeffnetVon = this.TankstelleGeoeffnetVon;
		result.TankstelleGeoeffnetBis = this.TankstelleGeoeffnetBis;
		result.TankstelleLatitude = this.TankstelleLatitude;
		result.TankstelleLongitude = this.TankstelleLongitude;
		return result;
	}

}